/**
 * Schornis Wasser-Kompass — Widget-Fassung (Camping Schorni, Du-Ansprache)
 * ---------------------------------------------------------------------------
 * Basiert auf public/js/kompass.js aus dem AquaVitales-Plugin (v1.4), aber:
 *  - rechnet LOKAL mit js/recommender.js (Anrede 'du') statt WordPress-REST
 *  - PDF-Button druckt die Seite (window.print) — kein Backend noetig
 *  - Lead-Formular ist in v0.1 deaktiviert (kein Backend); Markup folgt spaeter
 *  - Validierungs-Texte in Du-Ansprache
 * Quelle der Wahrheit fuer Logik & Daten bleibt 08_Arbeitsstand_v1.4!
 * Stand: 2026-08-01 (Claude, Auftrag Ulrike: "wechselt mal auf Camping Schorni")
 * v2.10 (15.09.2026, Barrierefreiheits-Paket): Inline-Fehlertexte statt alert(), Fokus auf die
 *   betroffene Frage bzw. den neuen Schritt, Pfeiltasten in Radiogruppen, Link-Fallback ohne prompt().
 * v2.9 (14.09.2026, Ulrike): Ergebnis-Link (?k=), Kopie an mich per Mail, Angaben-Liste in Ergebnis/Mail/Druck.
 * v2.8 (13.09.2026, Pruefbericht 12.09.): nur sichtbare Antworten rechnen, Positionszaehler/
 *   Preis-Luecken auf die aktive Auswahl, "Angaben aendern", eco/steel-Wahl bei KLW.
 *   Diese Datei ist die Quelle fuer 09_Schorni-Fassung_v0.1/js/kompass-widget.js (1:1-Kopie).
 */
window.avpkKompass = function () {
  return {
    // ---- State ----
    cfg: window.AVPK_DATA || {},
    currentStep: 0,
    answers: {
      tanks: [ { volumen: null, material: '' } ],
    },
    result: null,
    loading: false,
    lead: { name: '', email: '', consent: false, send_email: true },
    leadSent: false,
    pdfDownloading: false,
    wahl: {},   // Entscheidungs-Gruppen: { <gruppeId>: <optionId>, uv_modell: <sku> }
    // v2.10: Fehler stehen inline an der Frage statt in einem alert()-Dialog — Screenreader lesen
    // sie vor (role="alert"), der Fokus springt auf die Frage, und der Text verschwindet von
    // selbst, sobald die Antwort da ist.
    fehler: {},            // { <feldId>: 'Text' } — nur fuer den aktuellen Schritt
    fehlerAllgemein: '',   // z. B. Rechenfehler beim Berechnen
    linkFallback: '',      // Link als Textfeld, wenn die Zwischenablage nicht erreichbar ist

    // ---- Init ----
    _vorbelegen() {
      this.cfg.questions.steps.forEach( step => {
        step.fields.forEach( f => {
          if ( ( f.type === 'slider' || f.type === 'stepper' )
               && f.default !== undefined
               && this.answers[ f.id ] === undefined ) {
            this.answers[ f.id ] = f.default;
          }
        });
      });
    },
    init() {
      this._vorbelegen();
      this.recomputeDerived();
      // v29-07: Drucken ueber Browser-Menue/iOS-Teilen soll die Angaben ebenfalls aufklappen
      window.addEventListener( 'beforeprint', () => document.querySelectorAll( '.avpk-angaben' ).forEach( d => { d.open = true; } ) );
      this.$watch && this.$watch( 'answers.nutzungsprofil', () => this.applyProfileRange() );
      this.$watch && this.$watch( 'answers.personen', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.liter_pro_person_tag', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.reisedauer_kategorie', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.fahrzeugtyp', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.spuelmaschine', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.waschmaschine', () => this.recomputeDerived() );
      this.$watch && this.$watch( 'answers.versorgung', () => this.recomputeDerived() );
      // v2.10: Fehlertext an einer Frage verschwindet, sobald sie beantwortet ist
      this.$watch && this.$watch( 'answers', () => this.fehlerAufraeumen() );

      // Ergebnis ueber den Warenkorb-Klick hinweg merken: Der Warenkorb-Button
      // navigiert weg (/cart). Ohne das hier landet der Zurueck-Button im leeren
      // Fragebogen — Empfehlung, Begruendungen und PDF-Knopf waeren verloren
      // (Ulrike 02.08.2026). sessionStorage = gilt nur fuer diesen Tab.
      // v2.9 (Ulrike 14.09.2026): Ein geteilter Link (?k=…) stellt Antworten + Auswahl wieder her und
      // zeigt sofort das Ergebnis — fuer Handy/iPad ohne PDF-Druck und damit wir im Angebot sehen,
      // was der Kunde angeklickt hat.
      if ( ! this.restoreFromLink() ) this.restoreState();
      window.addEventListener( 'pagehide', () => this.saveState() );
      window.addEventListener( 'beforeunload', () => this.saveState() );
    },

    // ---- Zustand merken (nur diese Browser-Sitzung) ----
    STATE_KEY: 'avpk_kompass_state_v1',
    // v1.6 (Ulrike 03.08.2026): Der gemerkte Zustand darf NUR bei der Rueckkehr vom
    // Warenkorb greifen. Vorher wurde er bei jedem Besuch in derselben Browser-Sitzung
    // wiederhergestellt — wer den Kompass erneut oeffnete, landete sofort im Ergebnis
    // und sah den Fragebogen nie.
    RUECKKEHR_KEY: 'avpk_zurueck_vom_warenkorb',

    // Wird gesetzt, wenn der Kunde den Kompass ueber einen Link VERLAESST — Warenkorb
    // oder Produktseite. Nur dann darf der Zustand zurueckgeholt werden. Ohne das hier
    // landet der Zurueck-Knopf im leeren Fragebogen und die Empfehlung ist futsch
    // (Ulrike 05.08.2026: "kein Backlink mehr auf meine Vorschlagsliste").
    merkeAbsprung() {
      try { sessionStorage.setItem( this.RUECKKEHR_KEY, '1' ); } catch ( e ) {}
      this.saveState();
    },
    // Alter Name, bleibt als Weiche fuer bestehende Aufrufe.
    merkeWarenkorbSprung() {
      try { sessionStorage.setItem( this.RUECKKEHR_KEY, '1' ); } catch ( e ) {}
      this.saveState();
    },

    vergissZustand() {
      try {
        sessionStorage.removeItem( this.STATE_KEY );
        sessionStorage.removeItem( this.RUECKKEHR_KEY );
      } catch ( e ) {}
    },

    neuStarten() {
      this.vergissZustand();
      // v29-03: ohne ?k=… laden, sonst stellt der Link dieselbe Empfehlung wieder her
      window.location.replace( window.location.pathname );
    },

    saveState() {
      try {
        sessionStorage.setItem( this.STATE_KEY, JSON.stringify( {
          answers: this.answers,
          currentStep: this.currentStep,
          result: this.result,
          wahl: this.wahl
        } ) );
      } catch ( e ) { /* privater Modus / Speicher voll: dann eben ohne */ }
    },

    restoreState() {
      try {
        // Nur bei der Rueckkehr vom Warenkorb wiederherstellen — sonst frisch anfangen.
        const zurueck = sessionStorage.getItem( this.RUECKKEHR_KEY );
        if ( ! zurueck ) { this.vergissZustand(); return; }
        sessionStorage.removeItem( this.RUECKKEHR_KEY );
        const roh = sessionStorage.getItem( this.STATE_KEY );
        if ( ! roh ) return;
        const s = JSON.parse( roh );
        if ( ! s || typeof s !== 'object' ) return;
        if ( s.answers && typeof s.answers === 'object' ) this.answers = s.answers;
        if ( s.wahl && typeof s.wahl === 'object' ) this.wahl = s.wahl;
        if ( s.result ) this.result = s.result;
        if ( typeof s.currentStep === 'number' ) this.currentStep = s.currentStep;
        // addTank/removeTank und die Tank-Formeln setzen mindestens einen Eintrag voraus
        if ( ! Array.isArray( this.answers.tanks ) || ! this.answers.tanks.length ) {
          this.answers.tanks = [ { volumen: null, material: '' } ];
        }
        this.recomputeDerived();
      } catch ( e ) { /* kaputter Eintrag: lieber frisch anfangen */ }
    },

    applyProfileRange() {
      const profile = this.answers.nutzungsprofil;
      if ( ! profile ) return;
      const field = this.findField( 'liter_pro_person_tag' );
      if ( ! field || ! field.range_from_profile ) return;
      const cfg = field.range_from_profile[ profile ];
      if ( ! cfg ) return;
      field.min = cfg.min;
      field.max = cfg.max;
      field._label_min = cfg.label_min;
      field._label_max = cfg.label_max;
      const cur = this.answers.liter_pro_person_tag;
      if ( cur === undefined || cur < cfg.min || cur > cfg.max ) {
        this.answers.liter_pro_person_tag = cfg.default;
      }
      this.recomputeDerived();
    },

    recomputeDerived() {
      const personen = Number( this.answers.personen ) || 0;
      const lpp = Number( this.answers.liter_pro_person_tag ) || 0;
      this.answers.liter_pro_tag = personen * lpp;
      const kat = this.answers.reisedauer_kategorie;
      const reiseField = this.findField( 'reisedauer_kategorie' );
      if ( kat && reiseField ) {
        const opt = ( reiseField.options || [] ).find( o => o.value === kat );
        if ( opt ) {
          this.answers.reisedauer       = opt.mid;
          this.answers.reisedauer_min   = opt.min;
          this.answers.reisedauer_max   = opt.max;
        }
      }

      // Zweiter Wasserkreislauf: nur bei Weltreisemobil, Boot und Hausboot realistisch.
      // Kleinere Wohnmobile haben ihre Spuel-/Waschmaschine am einen Kreislauf mit
      // angeschlossen — dort wird gar nicht erst gefragt (Ulrike 02.08.2026).
      // Abgeleitetes Feld, weil visible_if nur EINEN exakten Wert vergleichen kann.
      const zweitkreisFahrzeug = [ 'weltreise', 'boot', 'hausboot' ].includes( this.answers.fahrzeugtyp );
      // Abnahme 13.09. (template-06): Spuelmaschine zaehlt nur, wenn die Frage sichtbar ist (Kueche = ja)
      const spF = this.findField( 'spuelmaschine' );
      const sp = ( spF && this.isVisible( spF ) ) ? this.answers.spuelmaschine : undefined;
      const hatMaschine = sp === 'ja' || this.answers.waschmaschine === 'ja';
      this.answers.zweitkreis_moeglich = ( zweitkreisFahrzeug && hatMaschine ) ? 'ja' : 'nein';
      if ( this.answers.zweitkreis_moeglich === 'ja' ) {
        // Ehrlich vorbelegen: "Weiss ich nicht" statt "gemeinsam" — sonst behaupten wir
        // eine Antwort, die der Kunde nie gegeben hat, und der Hinweis dazu bliebe aus.
        if ( ! this.answers.maschinen_kreislauf ) this.answers.maschinen_kreislauf = 'unbekannt';
      } else {
        this.answers.maschinen_kreislauf = undefined;     // Frage gar nicht gestellt
      }
      // Nur ein ausdrueckliches "eigener Kreislauf" nimmt die Maschine aus unserem System.
      // Nicht gefragt oder unbekannt = sie haengt dran (sichere Annahme, Ulrike 02.08.2026).
      this.answers.maschinen_am_kreislauf = ( this.answers.maschinen_kreislauf === 'eigen' ) ? 'nein' : 'ja';

      // Ueber 8 l/min an der Brause geht nur mit Stellplatzdruck. Im Tankbetrieb deckelt
      // die Pumpe: WMMP12-116 max. 11,6 l/min Open Flow (ohne Gegendruck) — mit Schlauch,
      // Filter, UV und Brausekopf bleibt real deutlich weniger uebrig. Die Duschen-Frage
      // waere dort eine Scheinfrage, die nur eine unnoetige zweite UV-Einheit ausloest
      // (Ulrike 02.08.2026).
      this.answers.city_druck = [ 'city', 'beides' ].includes( this.answers.versorgung ) ? 'ja' : 'nein';
      if ( this.answers.city_druck !== 'ja' ) this.answers.dusche_durchfluss = undefined;
    },

    findField( id ) {
      for ( const s of this.cfg.questions.steps ) {
        const f = ( s.fields || [] ).find( x => x.id === id );
        if ( f ) return f;
      }
      return null;
    },

    // ---- Step navigation ----
    get steps()      { return this.cfg.questions.steps; },
    get totalSteps() { return this.steps.length; },
    get isFirst()    { return this.currentStep === 0; },
    get isLast()     { return this.currentStep === this.totalSteps - 1; },
    get progress()   { return Math.round( ( ( this.currentStep + 1 ) / this.totalSteps ) * 100 ); },

    next() {
      if ( ! this.validateStep( this.currentStep ) ) return;
      if ( this.isLast ) {
        this.submit();
      } else {
        this.currentStep++;
        this.scrollToTop();
      }
    },
    prev() {
      if ( this.isFirst ) return;
      this.fehler = {};
      this.currentStep--;
      this.scrollToTop();
    },
    goTo( idx ) {
      if ( idx < 0 || idx >= this.totalSteps ) return;
      this.fehler = {};
      this.currentStep = idx;
      this.result = null;
      // wahl bleibt erhalten (Abnahme template-08): aufbereiten() prueft sie gegen die
      // vorhandenen Optionen und faellt sauber zurueck.
      this.scrollToTop();
    },
    // v2.8: Von der Ergebnisseite zurueck in den Fragebogen, OHNE die Antworten zu loeschen
    // (Pruefbericht ui-widget-qa-09). Danach "Empfehlung berechnen" erneut klicken.
    angabenAendern() {
      this.goTo( this.totalSteps - 1 );
    },
    scrollToTop() {
      const el = document.getElementById( 'avpk-root' );
      if ( el ) el.scrollIntoView( { behavior: 'smooth', block: 'start' } );
      this.fokusAufTitel();
    },
    // v2.10: Nach dem Blaettern bekommt die Ueberschrift des neuen Schritts (bzw. der
    // Ergebnisseite) den Fokus. Screenreader lesen dann den neuen Schritt vor; Tastaturnutzer
    // stehen nicht mehr auf einem "Weiter"-Knopf, der gerade aus dem DOM verschwunden ist.
    _tick( fn ) {
      if ( this.$nextTick ) this.$nextTick( fn ); else setTimeout( fn, 0 );
    },
    fokusAufTitel() {
      this._tick( () => {
        const sel = this.isResultView() ? '#avpk-ergebnis-titel' : '#avpk-schritt-' + this.currentStep + ' h2';
        const h = document.querySelector( sel );
        if ( h && h.focus ) h.focus( { preventScroll: true } );
      } );
    },
    // Fokus auf die erste Frage mit Fehler: das erste SICHTBARE Bedienelement in Dokumentreihenfolge —
    // bei Radiogruppen deren Tab-Stopp, bei der Tankliste das Volumen-Feld (der ausgeblendete
    // "Tank entfernen"-Knopf steht im DOM davor und wird uebersprungen).
    fokusAufFeld( id ) {
      this._tick( () => {
        const wrap = document.getElementById( 'avpk-feld-' + id );
        if ( ! wrap ) return;
        if ( wrap.scrollIntoView ) wrap.scrollIntoView( { behavior: 'smooth', block: 'center' } );
        const ziel = Array.from( wrap.querySelectorAll( '[role="radio"][tabindex="0"], input, button' ) )
          .find( el => el.offsetParent !== null );
        if ( ziel && ziel.focus ) ziel.focus( { preventScroll: true } );
      } );
    },
    // WAI-ARIA-Radiomuster: nur EIN Element der Gruppe liegt in der Tab-Reihenfolge — das
    // gewaehlte, sonst das erste. Die Pfeiltasten wandern innerhalb der Gruppe (pfeilNavigation).
    rovingTab( aktuell, wert, index, werte ) {
      const gewaehlt = ( werte || [] ).includes( aktuell );
      return ( gewaehlt ? aktuell === wert : index === 0 ) ? 0 : -1;
    },
    pfeilNavigation( ev ) {
      const vor = ev.key === 'ArrowRight' || ev.key === 'ArrowDown';
      const zurueck = ev.key === 'ArrowLeft' || ev.key === 'ArrowUp';
      if ( ! vor && ! zurueck ) return;
      const gruppe = ev.currentTarget && ev.currentTarget.closest ? ev.currentTarget.closest( '[role="radiogroup"]' ) : null;
      if ( ! gruppe ) return;
      const radios = Array.from( gruppe.querySelectorAll( '[role="radio"]' ) ).filter( r => r.offsetParent !== null );
      const i = radios.indexOf( ev.currentTarget );
      if ( i < 0 || radios.length < 2 ) return;
      ev.preventDefault();
      const n = radios[ ( i + ( vor ? 1 : radios.length - 1 ) ) % radios.length ];
      n.focus(); n.click();
    },
    // IDs fuer aria-describedby: Hinweistext + Fehlertext der Frage (nur was es gerade gibt)
    beschreibtIds( field ) {
      const ids = [];
      if ( field.hint || field.hinweis ) ids.push( 'avpk-hint-' + field.id );
      if ( this.fehler[ field.id ] ) ids.push( 'avpk-fehler-' + field.id );
      return ids.length ? ids.join( ' ' ) : null;
    },

    // ---- Conditional field visibility ----
    isVisible( field, antworten ) {
      const A = antworten || this.answers;
      if ( field.visible_if_set ) {
        const v = A[ field.visible_if_set ];
        if ( v === undefined || v === null || v === '' ) return false;
      }
      // visible_if_any: zeigt das Feld, wenn ein Mehrfachauswahl-Feld EINEN der Werte enthält
      // (z. B. Duschen-Durchfluss nur, wenn Dusche innen ODER außen angehakt ist)
      if ( field.visible_if_any ) {
        for ( const [ key, werte ] of Object.entries( field.visible_if_any ) ) {
          const v = A[ key ];
          if ( ! Array.isArray( v ) || ! werte.some( w => v.includes( w ) ) ) return false;
        }
      }
      // v1.7 (Ulrike 05.08.2026): Frage nur bei mehreren Tanks/Kanistern zeigen.
      if ( field.visible_if_min_tanks ) {
        const anzahl = Array.isArray( A.tanks )
          ? A.tanks.filter( t => t && t.volumen ).length : 0;
        if ( anzahl < field.visible_if_min_tanks ) return false;
      }
      if ( ! field.visible_if ) return true;
      for ( const [ key, expected ] of Object.entries( field.visible_if ) ) {
        const val = A[ key ];
        if ( typeof expected === 'object' && expected.contains ) {
          if ( ! Array.isArray( val ) || ! val.includes( expected.contains ) ) return false;
        } else if ( typeof expected === 'object' && Array.isArray( expected.in ) ) {
          // v1.6 (03.08.2026): "einer von mehreren" — gebraucht fuer die Tankfrage,
          // die bei Versorgung "tank" UND "beides" gestellt werden muss.
          if ( ! expected.in.includes( val ) ) return false;
        } else if ( val !== expected ) {
          return false;
        }
      }
      return true;
    },

    // ---- Validation (Du-Ansprache) ----
    // v2.10: kein alert() mehr. Alle fehlenden Pflichtangaben des Schritts werden gesammelt,
    // inline an der Frage angezeigt (role="alert") und die erste bekommt den Fokus.
    pruefeFeld( f ) {
      if ( f.type === 'computed' || ! f.required ) return null;
      if ( f.type === 'tank-list' ) {
        const t = Array.isArray( this.answers.tanks ) ? this.answers.tanks : [];
        return ( t.length && t[0] && t[0].volumen ) ? null : 'Bitte gib mindestens ein Tankvolumen an.';
      }
      const v = this.answers[ f.id ];
      if ( v === undefined || v === null || v === '' || ( Array.isArray( v ) && v.length === 0 ) ) {
        return 'Bitte beantworte noch diese Frage.';
      }
      return null;
    },
    validateStep( idx ) {
      const step = this.steps[ idx ];
      const neu = {};
      for ( const f of step.fields ) {
        if ( ! this.isVisible( f ) ) continue;
        const text = this.pruefeFeld( f );
        if ( text ) neu[ f.id ] = text;
      }
      this.fehler = neu;
      const erstes = Object.keys( neu )[ 0 ];
      if ( erstes ) { this.fokusAufFeld( erstes ); return false; }
      return true;
    },
    fehlerAufraeumen() {
      const ids = Object.keys( this.fehler );
      if ( ! ids.length ) return;
      const rest = {};
      for ( const id of ids ) {
        const f = this.findField( id );
        if ( f && this.isVisible( f ) && this.pruefeFeld( f ) ) rest[ id ] = this.fehler[ id ];
      }
      if ( Object.keys( rest ).length !== ids.length ) this.fehler = rest;
    },

    // ---- Tank list helpers ----
    addTank() {
      this.answers.tanks.push( { volumen: null, material: '' } );
    },
    removeTank( i ) {
      if ( this.answers.tanks.length <= 1 ) return;
      this.answers.tanks.splice( i, 1 );
    },

    // ---- Computed helpers ----
    computeFormula( formula ) {
      const a = this.answers;
      if ( formula === 'liter_pro_tag * reisedauer' ) {
        if ( a.reisedauer_min && a.reisedauer_max && a.liter_pro_tag ) {
          const mn = a.liter_pro_tag * a.reisedauer_min;
          const mx = a.liter_pro_tag * a.reisedauer_max;
          return mn === mx ? String( mn ) : `${mn}–${mx}`;
        }
        return ( a.liter_pro_tag || 0 ) * ( a.reisedauer || 0 );
      }
      if ( formula === 'personen * liter_pro_person_tag' ) {
        return ( Number( a.personen ) || 0 ) * ( Number( a.liter_pro_person_tag ) || 0 );
      }
      if ( formula === 'tank_reichweite_tage' ) {
        const lpt = Number( a.liter_pro_tag ) || 0;
        if ( lpt <= 0 ) return '—';
        return ( Math.round( ( 100 / lpt ) * 10 ) / 10 );
      }
      if ( formula === 'sum(tanks.volumen)' ) {
        return this.answers.tanks.reduce( ( s, t ) => s + ( parseInt( t.volumen ) || 0 ), 0 );
      }
      return '';
    },

    // ---- Checkbox toggle ----
    toggleCheckbox( fieldId, value ) {
      if ( ! Array.isArray( this.answers[ fieldId ] ) ) this.answers[ fieldId ] = [];
      const arr = this.answers[ fieldId ];
      const i = arr.indexOf( value );
      if ( i >= 0 ) arr.splice( i, 1 ); else arr.push( value );
    },
    isChecked( fieldId, value ) {
      return Array.isArray( this.answers[ fieldId ] ) && this.answers[ fieldId ].includes( value );
    },

    // ---- Submit: LOKAL rechnen statt REST (Kern-Unterschied zur Plugin-Fassung) ----
    submit() {
      this.loading = true;
      this.fehlerAllgemein = '';
      // kurze Pause, damit der Rechen-Moment sichtbar ist (UX, kein Fake-Ergebnis)
      setTimeout( () => {
        try {
          this.result = window.AVPKRecommender.recommend(
            this.sichtbareAntworten(), this.cfg.rules, this.cfg.catalog, { anrede: 'du' }
          );
          this.currentStep = this.totalSteps; // → Result-View
          this.loading = false;
          this.scrollToTop();                 // v2.10: Fokus auf "Deine persoenliche Empfehlung"
        } catch ( e ) {
          this.loading = false;
          this.fehlerAllgemein = 'Da ist etwas schiefgelaufen. Bitte versuch es noch einmal.';
          console.error( e );
        }
      }, 350 );
    },

    // v2.8 (Pruefbericht logik-qa-13): Eine Antwort, deren Frage inzwischen ausgeblendet ist
    // (z. B. Spuelmaschine=ja, nachdem die Kueche auf "nein" gestellt wurde), darf nicht
    // mitrechnen. Abgeleitete Felder (liter_pro_tag, city_druck, tanks ...) sind keine
    // Fragebogen-Felder und bleiben unangetastet.
    sichtbareAntworten() {
      const kopie = Object.assign( {}, this.answers );
      // Abnahme v29-G2: kaskadierend — eine Antwort, deren Frage nur wegen einer bereits
      // ausgeblendeten Antwort sichtbar waere (Kueche nein → Qualitaet → Filterstufe), faellt mit.
      for ( let runde = 0; runde < 5; runde++ ) {
        let geaendert = false;
        for ( const s of this.cfg.questions.steps ) {
          for ( const f of ( s.fields || [] ) ) {
            if ( f.type === 'computed' || kopie[ f.id ] === undefined ) continue;
            if ( ! this.isVisible( f, kopie ) ) { delete kopie[ f.id ]; geaendert = true; }
          }
        }
        if ( ! geaendert ) break;
      }
      return kopie;
    },

    submitLead() {
      // v0.1: kein Backend — Formular ist im Markup ausgeblendet.
      this.fehlerAllgemein = 'In dieser Vorschau noch ohne Funktion.';
    },

    downloadPdf() {
      document.querySelectorAll( '.avpk-angaben' ).forEach( d => { d.open = true; } );
      window.print();
    },

    // ---- View helpers ----
    isResultView() { return this.currentStep >= this.totalSteps && this.result; },

    formatPrice( v ) {
      return new Intl.NumberFormat( 'de-DE', { style: 'currency', currency: 'EUR' } ).format( v );
    },

    // Preisdarstellung: Shopify ist die Preisquelle (Ulrike 01.08.). Leitungsmaterial
    // wird als individuelles Angebot ausgewiesen; echte Luecken zeigen "Preis folgt".
    priceLabel( item, qty ) {
      if ( this.istAngebot( item ) ) return 'individuelles Angebot';
      if ( item.preis === null || item.preis === undefined ) return 'Preis folgt';
      const betrag = this.formatPrice( item.preis * ( qty !== undefined ? qty : item.qty ) );
      // "ab" bei Artikeln, bei denen im Shop noch eine preiswirksame Auswahl offen ist
      // (z. B. Anschluss und Absperrhahn beim Filtergehaeuse) — Ulrike 04.08.2026.
      // Der Katalog fuehrt das je Artikel als preis_ab; die Empfehlungs-Position
      // selbst traegt das Feld nicht, deshalb der Blick in den Katalog.
      const artikel = this._katalogArtikel( item.sku );
      return ( artikel && artikel.preis_ab ) ? 'ab ' + betrag : betrag;
    },
    // v2.8: auf die AKTIVE Auswahl (Umschalter) statt auf die Rohliste (Pruefbericht ui-widget-qa-04)
    hasOpenPrices() {
      if ( ! this.result ) return false;
      const g = this.gruppiert();
      return g.aktiveItems.concat( g.material ).some(
        i => ( i.preis === null || i.preis === undefined ) && ! this.istAngebot( i ) );
    },
    // v2.8: Positionszaehler = dieselbe Basis wie Warenkorb und Gesamtsumme (ui-widget-qa-03)
    anzahlPositionen() {
      if ( ! this.result ) return 0;
      const g = this.gruppiert();
      return g.aktiveItems.length + g.material.length;
    },

    // ---- GHS/CLP (Pflichtangaben vor dem Kaufbutton, Regel Ulrike) ----
    _katalogArtikel( sku ) {
      return ( this.cfg.catalog.products || [] ).find( p => p.sku === sku ) || null;
    },
    ghsFor( item ) {
      const p = this._katalogArtikel( item.sku );
      return ( p && p.ghs ) ? p.ghs : null;
    },
    ghsPikto( code ) {
      // Dieselben Piktogramm-Dateien wie auf den Shop-Produktseiten
      return 'https://cdn.shopify.com/s/files/1/0302/1248/9309/files/' + code + '.png';
    },
    // v2.11 (Justus 15.09.2026): Wirkstoff + BAuA-Registriernummer wie im Sicherheitshinweis-Block
    // des Shops (nach den H-Saetzen, vor dem Biozid-Satz). Nummer nur, wenn im Katalog belegt —
    // bei Sets je Komponente ("N-108213 (Silbernetz Flex) · N-86607 (DEXDA Clean)").
    ghsMeta( item ) {
      const g = this.ghsFor( item );
      if ( ! g ) return '';
      const teile = [];
      if ( g.wirkstoff ) {
        const set = /^Set:\s*/.test( g.wirkstoff );
        teile.push( ( set ? 'Bestandteile: ' : 'Wirkstoff: ' ) + g.wirkstoff.replace( /^Set:\s*/, '' ) );
      }
      if ( g.baua ) teile.push( 'BAuA-Registriernummer: ' + g.baua );
      return teile.join( ' · ' );
    },
    istAngebot( item ) {
      const p = this._katalogArtikel( item.sku );
      return !! ( p && p.angebot );
    },
    // PAngV §4: Grundpreis bei Volumenware, in unmittelbarer Naehe des Gesamtpreises
    grundpreisFor( item ) {
      const p = this._katalogArtikel( item.sku );
      return ( p && p.grundpreis ) ? p.grundpreis : null;
    },

    // ---- Warenkorb (Shopify Cart-Permalink /cart/VARIANT:MENGE,...) ----
    _variantId( sku ) {
      const v = ( this.cfg.shop_links && this.cfg.shop_links.variants ) || {};
      return v[ sku ] || null;
    },
    // Positionen, die in den Warenkorb koennen (Angebots-Artikel und fehlende
    // Shop-Varianten bleiben bewusst draussen — siehe warenkorbFehlend()).
    warenkorbPositionen() {
      if ( ! this.result ) return [];
      const g = this.gruppiert();
      return g.aktiveItems.concat( g.material )
        .filter( i => ! this.istAngebot( i ) && this._variantId( i.sku ) );
    },
    warenkorbFehlend() {
      if ( ! this.result ) return [];
      const g = this.gruppiert();
      return g.aktiveItems.concat( g.material )
        .filter( i => ! this.istAngebot( i ) && ! this._variantId( i.sku ) );
    },
    warenkorbUrl() {
      const teile = this.warenkorbPositionen()
        .map( i => this._variantId( i.sku ) + ':' + Math.max( 1, parseInt( i.qty ) || 1 ) );
      // ?storefront=true ist PFLICHT: ohne den Parameter leitet Shopify den
      // Cart-Permalink direkt in den CHECKOUT um. Der Kunde soll aber erst in den
      // Warenkorb, um prüfen und ändern zu können (geprüft 02.08.2026).
      if ( ! teile.length ) return null;
      // v2.9 (Ulrike 14.09.2026): Die Kompass-Angaben wandern als Bestell-Attribut mit in den
      // Warenkorb — in der Bestellung steht dann unter "Zusaetzliche Details" der Link, der die
      // Empfehlung samt allen Antworten oeffnet. Nur bei Bestellung/Anfrage, keine Statistik.
      const attr = '&attributes[Wasser-Kompass]=' + encodeURIComponent( this.ergebnisLink() );
      return '/cart/' + teile.join( ',' ) + '?storefront=true' + attr;
    },

    // v2.8 (Pruefbericht nach3-01): Die Ergebnisseite verspricht ein individuelles Angebot,
    // bot aber keinen Kontaktweg. mailto: braucht kein Backend und keine Datenschutz-Strecke —
    // der Kunde schreibt aus seinem eigenen Postfach, die Liste ist vorausgefuellt.
    // v2.10: Die Adresse war beim v2.9-Umbau verloren gegangen — live stand seit 14.09. 19:33
    // "mailto:undefined" im Knopf "Angebot anfragen". Wird jetzt von tests/test-widget.js bewacht.
    KONTAKT_MAIL: 'info@caravan-reiniger.de',
    KONTAKT_TEL: '04959 9155100',
    // ---- Ergebnis teilen: Link, Kopie an mich, Angaben-Liste (v2.9) ----
    _b64url( str ) {
      return btoa( unescape( encodeURIComponent( str ) ) ).replace( /\+/g, '-' ).replace( /\//g, '_' ).replace( /=+$/, '' );
    },
    _b64urlDecode( str ) {
      str = str.replace( /-/g, '+' ).replace( /_/g, '/' );
      while ( str.length % 4 ) str += '=';
      return decodeURIComponent( escape( atob( str ) ) );
    },
    // Kurzschluessel fuer den Link (haelt ihn unter ~600 Zeichen); unbekannte Felder laufen unter ihrer ID.
    LINK_KURZ: { fahrzeugtyp: 'ft', reiseregion: 'rr', nutzungsprofil: 'np', reisedauer_kategorie: 'rd', personen: 'pe',
      liter_pro_person_tag: 'lp', quellen: 'qu', vorfiltration: 'vf', uv_einbau: 'uv', versorgung: 'vs', tanks: 'tk',
      tanks_verbunden: 'tv', umkehrosmose: 'uo', standzeit_tage: 'sz', boiler: 'bo', kueche: 'ku', kueche_qualitaet: 'kq',
      kueche_filterstufe: 'kf', spuelmaschine: 'sm', waschmaschine: 'wm', maschinen_kreislauf: 'mk', zapfstellen: 'zs',
      dusche_durchfluss: 'dd', gleichzeitig: 'gz', fahrzeuggroesse: 'fg', fahrzeuglaenge_m: 'fl', schlauchsystem: 'ss',
      weg_tank_kueche: 'wk', weg_tank_bad: 'wb', pumpe_vorhanden: 'pv', bordnetz: 'bn', einbau: 'eb',
      revisionsoeffnung: 'ro', leitungen_vorhanden: 'lv', leitungsart: 'la' },   // v2.12 (21.09.2026); 'vf' bleibt fuer alte Links; 'la' 20.10.2026
    _fragefelder() {
      const out = {};
      for ( const s of this.cfg.questions.steps ) for ( const f of ( s.fields || [] ) ) if ( f.type !== 'computed' ) out[ f.id ] = f;
      return out;
    },
    ergebnisLink() {
      const a = this.sichtbareAntworten();
      const felder = this._fragefelder();
      const nutz = {};
      for ( const id in felder ) {
        const v = a[ id ];
        if ( v === undefined || v === null || v === '' ) continue;
        const key = this.LINK_KURZ[ id ] || id;
        nutz[ key ] = ( id === 'tanks' )
          ? ( v || [] ).filter( t => t && t.volumen ).map( t => [ Number( t.volumen ), t.material || '' ] )
          : v;
      }
      const code = this._b64url( JSON.stringify( { v: 2, a: nutz, w: this.wahl } ) );
      return window.location.origin + window.location.pathname + '?k=' + code;
    },
    // Nur bekannte Felder, nur plausible Typen — ein manipulierter Link kann nichts anrichten.
    _antwortenAusLink( roh ) {
      const felder = this._fragefelder();
      const lang = {}; for ( const id in this.LINK_KURZ ) lang[ this.LINK_KURZ[ id ] ] = id;
      const out = { tanks: [ { volumen: null, material: '' } ] };
      const okStr = v => typeof v === 'string' && v.length <= 60;
      const okNum = v => typeof v === 'number' && isFinite( v ) && v >= 0 && v <= 100000;
      const klemm = ( f, v ) => Math.min( f.max !== undefined ? Number( f.max ) : v, Math.max( f.min !== undefined ? Number( f.min ) : v, v ) );
      for ( const key of Object.keys( roh ) ) {
        const id = lang[ key ] || key;
        if ( id === '__proto__' || id === 'constructor' || ! felder[ id ] ) continue;
        const f = felder[ id ], v = roh[ key ];
        if ( f.type === 'tank-list' ) {
          if ( ! Array.isArray( v ) ) continue;
          const tanks = v.slice( 0, 10 ).map( t => Array.isArray( t ) ? { volumen: Number( t[0] ), material: okStr( t[1] ) ? t[1] : '' }
                                                  : ( t && typeof t === 'object' ) ? { volumen: Number( t.volumen ), material: okStr( t.material ) ? t.material : '' } : null )
                         .filter( t => t && okNum( t.volumen ) && t.volumen > 0 )
                         .map( t => ( { volumen: Math.min( 2000, Math.max( 5, t.volumen ) ), material: t.material } ) );
          if ( tanks.length ) out.tanks = tanks;
        } else if ( f.type === 'checkbox-group' ) {
          if ( Array.isArray( v ) ) out[ id ] = v.slice( 0, 20 ).filter( okStr );
        } else if ( f.type === 'slider' || f.type === 'stepper' ) {
          if ( okNum( v ) ) out[ id ] = klemm( f, v );
        } else if ( okStr( v ) ) {
          out[ id ] = v;
        }
      }
      return out;
    },
    restoreFromLink() {
      try {
        const code = new URLSearchParams( window.location.search ).get( 'k' );
        if ( ! code || code.length > 6000 ) return false;
        const s = JSON.parse( this._b64urlDecode( code ) );
        if ( ! s || typeof s !== 'object' || ! s.a || typeof s.a !== 'object' ) return false;
        this.answers = this._antwortenAusLink( s.a );
        this._vorbelegen();                                 // v2.10: fehlende Slider/Stepper auf Vorgabe statt undefined
        if ( ! this.answers.fahrzeugtyp ) {                 // ohne Grundangabe kein Ergebnis — lieber Fragebogen
          this.answers = { tanks: [ { volumen: null, material: '' } ] }; this._vorbelegen(); this.recomputeDerived();
          return false;
        }
        // nur bekannte Wahl-Schluessel: Gruppen-IDs, uv_modell, <option>_modell
        const erlaubt = new Set( [ 'uv_modell' ] );
        ( this.cfg.alternativen.gruppen || [] ).forEach( g => { erlaubt.add( g.id ); ( g.alternativen || [] ).forEach( a => erlaubt.add( a.id + '_modell' ) ); } );
        const w = {};
        if ( s.w && typeof s.w === 'object' ) {
          for ( const k of Object.keys( s.w ).slice( 0, 12 ) ) {
            if ( erlaubt.has( k ) && typeof s.w[ k ] === 'string' && s.w[ k ].length <= 40 ) w[ k ] = s.w[ k ];
          }
        }
        this.wahl = w;
        try { sessionStorage.removeItem( this.RUECKKEHR_KEY ); } catch ( e ) {}   // v29-06
        this.recomputeDerived();
        this.result = window.AVPKRecommender.recommend(
          this.sichtbareAntworten(), this.cfg.rules, this.cfg.catalog, { anrede: 'du' } );
        this.currentStep = this.totalSteps;
        return true;
      } catch ( e ) {
        this.answers = { tanks: [ { volumen: null, material: '' } ] }; this.wahl = {}; this.result = null; this.currentStep = 0;
        this._vorbelegen(); this.recomputeDerived();
        return false;
      }
    },
    linkKopiert: false,
    async linkKopieren() {
      const url = this.ergebnisLink();
      try {
        await navigator.clipboard.writeText( url );
        this.linkKopiert = true;
        this.linkFallback = '';
        setTimeout( () => { this.linkKopiert = false; }, 3000 );
      } catch ( e ) {
        // v2.10: statt window.prompt() ein Textfeld unter den Knoepfen — markiert sich selbst,
        // bleibt sichtbar und ist auch fuer Screenreader/Zoom erreichbar.
        this.linkFallback = url;
        this._tick( () => {
          const el = document.getElementById( 'avpk-link-out' );
          if ( el ) { el.focus(); el.select && el.select(); }
        } );
      }
    },
    // Alle beantworteten Fragen mit Klartext-Antwort (fuer Ergebnisseite, Druck und E-Mail)
    angabenListe() {
      const a = this.sichtbareAntworten();
      const out = [];
      const opt = ( f, v ) => { const o = ( f.options || [] ).find( x => x.value === v ); return o ? o.label : String( v ); };
      for ( const s of this.cfg.questions.steps ) {
        for ( const f of ( s.fields || [] ) ) {
          if ( f.type === 'computed' || ! this.isVisible( f, a ) ) continue;
          const v = a[ f.id ];
          if ( v === undefined || v === null || v === '' || ( Array.isArray( v ) && ! v.length ) ) continue;
          let text;
          if ( f.type === 'tank-list' ) {
            const mat = m => m ? m.charAt( 0 ).toUpperCase() + m.slice( 1 ) : '';
            text = ( v || [] ).filter( t => t && t.volumen ).map( ( t, i ) => 'Tank ' + ( i + 1 ) + ': ' + Number( t.volumen ).toLocaleString( 'de-DE' ) + ' l' + ( t.material ? ' (' + mat( t.material ) + ')' : '' ) ).join( ', ' );
          } else if ( f.type === 'checkbox-group' ) {
            text = v.map( x => opt( f, x ) ).join( ', ' );
          } else if ( f.type === 'yesno' ) {
            text = v === 'ja' ? 'Ja' : v === 'nein' ? 'Nein' : String( v );
          } else if ( f.type === 'slider' || f.type === 'stepper' ) {
            text = Number( v ).toLocaleString( 'de-DE' ) + ( f.unit ? ' ' + f.unit : '' );
          } else {
            text = opt( f, v );
          }
          if ( text ) out.push( { frage: f.label, antwort: text } );
        }
      }
      return out;
    },
    // Kopie der Empfehlung an die eigene Adresse — ohne Backend, ohne PDF (v2.9)
    kopieMailto( buffer ) {
      if ( ! this.result ) return 'mailto:';
      const g = this.gruppiert();
      const z = [ 'Meine Empfehlung aus Schornis Wasser-Kompass (camping-schorni.de):', '' ];
      g.aktiveItems.forEach( i => z.push( '- ' + i.name.replace( / \(Meterware\)/, '' ) + ( i.qty > 1 ? ' ×' + i.qty : '' ) ) );
      if ( g.material.length ) z.push( '- Leitungsmaterial als individuelles Angebot (Mengen im Link)' );
      z.push( '', 'Empfehlung mit allen Angaben wieder öffnen: ' + this.ergebnisLink() );
      return 'mailto:?subject=' + encodeURIComponent( 'Meine Wasser-Kompass-Empfehlung' ) + '&body=' + encodeURIComponent( z.join( '\n' ) );
    },

    // Kompakt gehalten: Windows-Outlook bricht mailto-Links ab ~2.000 Zeichen ab. Die
    // Komponenten und alle Angaben stecken im Link (oeffnet die Empfehlung samt "Deine Angaben").
    angebotMailto( buffer ) {
      if ( ! this.result ) return 'mailto:' + this.KONTAKT_MAIL;
      const g = this.gruppiert();
      const a = this.sichtbareAntworten();
      const zuschlag = Number( buffer ) || 0;
      const label = ( id ) => {
        const f = this.findField( id ); const v = a[ id ];
        if ( v === undefined || v === null || v === '' ) return null;
        const o = f && ( f.options || [] ).find( x => x.value === v );
        return o ? o.label : ( v === 'ja' ? 'Ja' : v === 'nein' ? 'Nein' : String( v ) );
      };
      const z = [ 'Hallo Camping Schorni,', '',
        'bitte um ein Angebot für das Leitungsmaterial aus dem Wasser-Kompass' + ( zuschlag ? ' (inkl. ' + zuschlag + ' % Zuschlag)' : '' ) + ':' ];
      g.material.forEach( i => z.push( '- ' + i.name.replace( / \(Meterware\)/, '' ) + ': ca. ' + Math.ceil( i.qty * ( 1 + zuschlag / 100 ) ) + ' ' + ( i.einheit || 'Stk' ) ) );
      const fz = [ label( 'fahrzeugtyp' ), label( 'fahrzeuggroesse' ), label( 'schlauchsystem' ), a.boiler ? 'Boiler ' + label( 'boiler' ) : null, a.pumpe_vorhanden ? 'Pumpe: ' + label( 'pumpe_vorhanden' ) : null, a.einbau ? 'Einbau: ' + label( 'einbau' ) : null ].filter( Boolean );
      z.push( '', 'Fahrzeug: ' + fz.join( ', ' ) );
      z.push( 'Empfehlung + alle Angaben: ' + this.ergebnisLink() );
      z.push( '', 'Fragen / Besonderheiten:', '', 'Viele Grüße' );
      return 'mailto:' + this.KONTAKT_MAIL
        + '?subject=' + encodeURIComponent( 'Angebot Leitungsmaterial – Wasser-Kompass' )
        + '&body=' + encodeURIComponent( z.join( '\n' ) );
    },

    iconUrl( file ) { return ( this.cfg.plugin_url || '' ) + 'img/' + file; },
    productImg( file ) {
      // 20.10.2026: Ist der Name eine SKU aus image_map, kommt das Shop-Produktfoto (verkleinert auf 360 px);
      // sonst wie bisher plugin_url + img/ (Prüfbericht 12.09., ui-widget-qa-06).
      const map = this.cfg.image_map || {};
      if ( file && map[ file ] ) return map[ file ] + ( map[ file ].includes( '?' ) ? '&' : '?' ) + 'width=360';
      return ( this.cfg.plugin_url || '' ) + 'img/' + ( file || '' );
    },

    // Echtes Shopify-Produktfoto per SKU (data/image-map), Fallback auf altes bild-Feld
    // Ohne Bild: null (Alpine entfernt das src-Attribut, keine 404-Anfrage) — Abnahme template-09
    productImgBySku( item ) {
      const map = this.cfg.image_map || {};
      if ( map[ item.sku ] ) return map[ item.sku ];
      return item.bild ? this.productImg( item.bild ) : null;
    },

    // Echter Produktbeschreibungs-Absatz aus der Shop-Produktseite (data/beschreibung-map)
    beschreibungFor( item ) {
      const map = this.cfg.beschreibung_map || {};
      return map[ item.sku ] || null;
    },

    // Link zur passenden Produktseite im Camping-Schorni-Shop (data/shop-links.json)
    shopUrl( item ) {
      const links = ( this.cfg.shop_links && this.cfg.shop_links.links ) || {};
      return links[ item.sku ] || null;
    },

    // ---- Entscheidungs-Gruppen (js/alternativen.js) ----
    gruppiert() {
      return window.AVPKAlternativen.aufbereiten(
        this.result, this.cfg.alternativen, this.cfg.catalog, this.answers, this.wahl, 'du'
      );
    },
    aktiveOption( g ) {
      return g.optionen.find( o => o.id === g.aktiv ) || g.optionen[0];
    },
    waehle( gruppeId, optionId ) {
      this.wahl = { ...this.wahl, [ gruppeId ]: optionId };
    },
    waehleModell( sku ) {
      this.wahl = { ...this.wahl, uv_modell: sku, uv: 'einzeln' };
    },
    // v2.8: Ausstattungswahl an einer Alternativ-Option (KLW eco/steel) — wahlfeld kommt aus alternativen.js
    waehleOptionModell( wahlfeld, key ) {
      this.wahl = { ...this.wahl, [ wahlfeld ]: key };
    },
  };
};
